import React, { SVGProps } from 'react'
export const FourthActiveLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.013 20.003c.325 13.653 9.205 16.332 15.986 15.965V1C9.083 1-.394 2.936.013 20.003Z"
    />
  </svg>
)
